/* 
This code handles the vp_btn status for home.php buendnis.php and single.php
it's done by session storage

clikcing th vp_btn saves it's id to sessions storage.
clicking the menu item alliance set's the value to biotechnology -> first btn
*/

// scrollbar
import RuOverlayScrollbar from "./../components/overlayscrollbars.js";

// vp_btns
const vpBtnNodes = document.querySelectorAll(".vp_btn");
// categories
const catNodes = document.querySelectorAll(".alliance_postgrid");

document.addEventListener("DOMContentLoaded", function () {
  //////////////////////////////////////
  // Scrollbar for vp buttons
  const vpAllianceScrollbar = new RuOverlayScrollbar("#scrollbars_vpalliance");
  // Scrollbar END
  //////////////////////////////////////

  //////////////////////////////////////
  // Test function
  /*   const storrageItem = () => {
    console.log("storrage test");
    if (sessionStorage.getItem("vpbtncat") === null) {
      console.log("no storage");
    } else {
      console.log("storage", sessionStorage.getItem("vpbtncat"));
    }
  };
  storrageItem(); */

  ////////////////
  // show/hide click handler - logos
  vpBtnNodes.forEach((btn) => {
    // add eventlistener
    btn.addEventListener("click", (e) => {
      e.preventDefault(); // prevent link behavior
      const vpAttr = btn.getAttribute("vp");
      sessionStorage.setItem("vpbtncat", vpAttr);
      displayCats(e.target); // show/hide cats
      return;
    });
  });

  ////////////////
  // show/hide fn
  const displayCats = (e) => {
    let catIndex = "";
    // check if storrage contains vp
    if (sessionStorage.getItem("vpbtncat")) {
      // get value from storrage
      catIndex = sessionStorage.getItem("vpbtncat");
    } else {
      // if no item -> set storrage and variable to inital cat 0
      sessionStorage.setItem("vpbtncat", 0);
      catIndex = 0;
    }
    // console.log("catIndex", catIndex);
    catNodes.forEach((arrayItem, index) => {
      if (index == catIndex) {
        arrayItem.style.display = "flex";
        // console.log("flex", index);
      } else {
        arrayItem.style.display = "none";
        // console.log("none", index);
      }
    });
    toggleCatBtn(e); // change the btn
  };

  // toggle active on the buttons
  const toggleCatBtn = (e) => {
    console.log("e", e);
    const clicked = e.closest(".vp_btn"); // get the parent of clicked element
    // add/remove the clicked classes
    if (clicked.classList.contains("vpbtn_active")) {
      return;
    } else {
      vpBtnNodes.forEach((btn) => {
        btn.classList.remove("vpbtn_active");
      });
      clicked.classList.add("vpbtn_active");
    }
  };

  ////////////////
  // intial Value for btns based on sessionstorrage
  const initialCatValue = '[vp="' + sessionStorage.getItem("vpbtncat") + '"]'; // selection btn with stored vp attribute
  const initialCat = document.querySelector(initialCatValue); // current node
  // check if session item is set
  if (initialCat) {
    displayCats(initialCat);
  } else {
    displayCats(1);
  }
});
